import React, { useMemo, useState } from 'react';

import connect from 'components/lib/connect';
import { getCustomerLanguageCode } from 'actions/conversation/lib/conversation_helpers';

export const DEFAULT_AI_TEXT_COMPLETION_CONTEXT = {
  // The current completion for a given requestorId
  completion: null,
  isLoading: false,
  // When an agent uses a completion, this function will be invoked, setting textToInsert, which
  // will be inserted into the editor after the editor exits readOnly mode.
  setTextToInsert: () => {},
  targetLanguage: null,
  textToInsert: null,
  // A unique ID for any given text completion context. Theoretically you could have multiple
  // simultaneous completions active on a page; maybe one for a note composer and one for a task
  // comment composer. But we never need more than one active completion at a time per context.
  requestorId: null,
};

const AITextCompletionContext = React.createContext(DEFAULT_AI_TEXT_COMPLETION_CONTEXT);

export function AiTextEditContextProviderBase({ children, completion, isLoading, requestorId, targetLanguage }) {
  const [textToInsert, setTextToInsert] = useState(null);

  const value = useMemo(
    () => ({
      completion,
      isLoading,
      requestorId,
      setTextToInsert,
      targetLanguage,
      textToInsert,
    }),
    [completion, requestorId, isLoading, targetLanguage, textToInsert]
  );

  return <AITextCompletionContext.Provider value={value}>{children}</AITextCompletionContext.Provider>;
}

const AITextCompletionContextProvider = connect(mapStateToProps)(AiTextEditContextProviderBase);

function mapStateToProps({ getProvider }, { requestorId }) {
  const completionsProvider = getProvider('aiTextCompletions');
  const conversationHistoryStore = getProvider('conversationHistory');
  const conversationsStore = getProvider('conversations');
  const customerLanguageStore = getProvider('customerLanguage');

  return {
    completion: completionsProvider.findBy({ id: requestorId }),
    isLoading: completionsProvider.isLoading({ id: requestorId }),
    targetLanguage: getCustomerLanguageCode({
      conversationsStore,
      conversationHistoryStore,
      customerLanguageStore,
    }),
  };
}

export default AITextCompletionContext;
export { AITextCompletionContextProvider };
